import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  slug: {
    id: "parentAttrSlug",
    defaultMessage: "Attribute Code",
  },
  name: {
    id: "parentAttrName",
    defaultMessage: "Name",
  },
  children: {
    id: "parentAttrChildren",
    defaultMessage: "Child Attributes",
  },
});

export const messages = defineMessages({
  empty: {
    id: "parentAttrEmpty",
    defaultMessage: "No parent attributes found",
  },
});